module.exports = __webpack_public_path__ + "media/src/public/images/arvida/logo-and-name-arvida-b1f1d758ab0c3955073697a419ca5840.png";